/* eslint-disable local-rules/no-direct-import */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
import { lazy, Suspense, useCallback, useEffect, useRef } from 'react';

import cx from 'classnames';
import qs from 'qs';
import { withCookies } from 'react-cookie';
import { isMobile } from 'react-device-detect';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import Notifications from 'react-notification-system-redux';
import { useDispatch, useSelector } from 'react-redux';
import MediaQuery from 'react-responsive';
import { Redirect, Route, Switch, useHistory } from 'react-router';

import { changeBasketOrdersScreen, toggleBasketOrdersView } from 'actions/basketOrders';
import { togglePhoneVerificationModal } from 'actions/other';
import { toggleSpotModal } from 'actions/spot';
import { userConnected, userDisconnected } from 'actions/user';
import { closeCurrencyConverterPopup } from 'actions/wallet';
import { MobileAlgoResources } from 'components/algoResources/MobileAlgoResources';
import { AnalyticsTrackingGlobal } from 'components/analytics/AnalyticsTrackingGlobal';
import { AnalyticsTrackingIndia } from 'components/analytics/AnalyticsTrackingIndia';
import GoogleOneTapLogin from 'components/Auth/GoogleOneTapLogin';
import BalanceWalletCoin from 'components/balanceWalletCoin';
import PhoneVerification from 'components/common/PhoneVerificationCode/PhonveVerificationScreen';
import ConvertBlockedPopup from 'components/convertBlockedPopup/convertBlockedPopup';
import { Setup2faModal } from 'components/Disable2faFaceAuth/Setup2faModal/Setup2faModal';
import ErrorBoundary from 'components/error_boundary';
import IndiaOrGlobalModal from 'components/IndiaOrGlobalModal';
import { CenterLoader } from 'components/loader';
import Logos from 'components/logos/Logos';
import MandatoryDeclarationModal from 'components/MandatoryDeclarationModal/MandatoryDeclarationModal';
import SoftAsk from 'components/moengage/SoftAsk';
import NriModalWrapper from 'components/NRIFlow/lazyNriModal';
import NriStripWrapper from 'components/NRIFlow/lazyNriStrip';
import { LEADERBOARD_SCREENS } from 'components/OptionsLeaderBoard/types';
import { RecaptchaRoot } from 'components/RecaptchaRoot/RecaptchaRoot';
import { RekycDetailsVerification } from 'components/RekycVerification/rekycDetailsVerification';
import Render from 'components/render';
import {
  RenderByExchange,
  RenderForIndianExchange,
} from 'components/render/RenderByExchangeType';
import { RNLoader } from 'components/rnLoader';
import { isOnSpotRouteNative } from 'components/SpotTradingIndia/Modal/helpers';
import {
  BASKET_ORDERS_SCREEN_VIEW,
  contractTypeRedirection,
  DISABLE_SEARCH_ENGINE_CRAWLING,
  EXCHANGE_PREFERENCE_FEATURE_FLAG,
  EXCHANGE_PREFERENCE_SESSION_DURATION,
  FOOTER_PATH_LARGE_SCREENS_PATHS,
  IND_DOMAIN_SWITCH,
  IS_DEMO,
  IS_INDIAN_EXCHANGE,
  IS_NATIVE_MARKETS_SCREEN,
  IS_RN_HOME_SCREEN,
  isDevnet,
  isRNWebview,
  LOCAL_STORAGE_KYC_POPUP_KEY,
  SHOW_2FA_RESET_POP_UP,
  SHOW_ACCOUNT_REFRESH_TRIGGER_STRIP,
  SHOW_CONNECTION_STRIP,
  SHOW_CONNECTION_STRIP_MOBILE,
  SHOW_LIQUIDATION_RISK,
  SHOW_MAINTENANCE_NOTIF,
  SHOW_MOBILE_FOOTER,
  SHOW_POPUPS,
  SHOW_PRIMARY_HEADER,
  SHOW_PRIMARY_HEADER_MOBILE,
  SHOW_SCALPER_OFFER_STRIP_ROUTES,
  // INFORMATION_STRIP,
  SHOW_TRADING_REVOKED_STRIP,
} from 'constants/constants';
import { POST_MESSAGE_TO_MOBILE_EVENTS, STORAGE_KEYS } from 'constants/enums';
import {
  FORGOT_EMAIL_ID_ENABLED,
  RECOVER_USER_ACCOUNT_FEATURE_ENABLED,
  SCALPING_ENABLED,
} from 'constants/featureFlag';
import { FORCE_APP_UPDATE_FOR_NATIVE } from 'constants/rnApp';
import routes, {
  AUTH_PAGE_ROUTES,
  MARKET_PAGE_URLS,
  TRADE_PAGE_URLS,
} from 'constants/routes';
import { resetGrowthBookUser, setGrowthBookUserID } from 'growthbook';
import { collectAndPushPerformanceDataToMixpanel } from 'helpers/performanceTracking';
import { equals, pipe } from 'helpers/ramda';
import { device } from 'helpers/screenSizes';
import { generateExchangeURL, navigateTo } from 'helpers/url';
import { isUserIndian, isUserRegisteredBeforeKYCDate } from 'helpers/user';
import {
  checkEnvironmentMessageCondition,
  handleInputBlurOnScroll,
  isDemo,
  isUserAtleastOneLevelVerified,
  shouldKYCPopupAppear,
  shouldShowKycUpgradeStrip,
  shouldShowKycUpgradeWarning,
  shouldShowStateUpdateModal,
} from 'helpers/utils';
import { useSendUserAuthorizedMessageToMobile } from 'hooks/componentHooks/useSendUserAuthorizedToMobile';
import useAppOnlineStatus from 'hooks/useAppOnlineStatus';
import { useChatwootWidget } from 'hooks/useChatwootWidget';
import { useFullScreenChangeNotifyApp } from 'hooks/useFullScreenChangeNotifyApp';
import useLocalStorage from 'hooks/useLocalStorage';
import useMediaQuery from 'hooks/useMediaQuery';
import usePageVisibility from 'hooks/usePageVisibility';
import useRNMessageEvents from 'hooks/useRNMessageEvents';
import useScrollToTopOnRouteChange from 'hooks/useScrollToTop';
import useSpotModalFromURL from 'hooks/useSpotModalFromURL';
import { useSpotSubscription } from 'hooks/useSpotSubscription';
import { useTrackierMobileMessage } from 'hooks/useTrackierMobileMessage';
import { isNotEmpty } from 'ramdax';
import { APP_DRAWER_TAB_ID_MAPPING } from 'reducers/initialstate/appDrawer';
import { activeInputFocusStatusSelector } from 'selectors/mobileOrderBookOverLayoutSelector';
import {
  appDrawerSelector,
  isUserPermissionForLiveChatSelector,
  otherSelector,
  selectIsCorporateUser,
  userSelector,
} from 'selectors/otherSelectors';
import { isSpotModalOpenSelector } from 'selectors/spotSelector';
import { tradingViewChartSelector } from 'selectors/tradingViewSelector';
import { selectIsAuthChannelFailed, selectIsVerifiedIndianUser } from 'selectors/user';
import { useAppSelector } from 'storeHooks';
import { MenuBackButton } from 'UIKit/menuBackButton/MenuBackButton';

import './app.scss';
import AppWrapper from './appStyle';
import { postMessageToMobileApp, showComponentOnSelectedRoute } from './helpers';
import PortalContainers from './portalContainers';
import {
  AccountHeader,
  AccountRefreshTriggerStrip,
  CurrencyConverter,
  DeltaIndiaStrip,
  ForceAppUpdatePopup,
  GenericPopup,
  InformationStrip,
  KycModal,
  KycRefreshDeadlineStrip,
  KycUpgradeCountdownStrip,
  KycUpgradeModal,
  LiquidationRiskBanner,
  MaintenanceBanner,
  PrimaryHeader,
  PrimaryHeaderMobile,
  ResetPasswordPopup,
  ScalperOfferStrip,
  TradingRevokedStrip,
  TradingViewPrimaryHeader,
} from './routes/common';
import {
  AsyncHomePage,
  AsyncMarkets,
  AsyncTrade,
  AsyncTradingViewChart,
} from './routes/mobileTopLevel';
import {
  AppFooter,
  AsyncAccount,
  AsyncAlgoMarketplace,
  AsyncApi,
  AsyncAppDrawer,
  AsyncBellAlerts,
  AsyncCalculatorPage,
  AsyncDisable2FA,
  AsyncExpiredFuturesPage,
  AsyncExpiredProductCharts,
  AsyncForgotEmailId,
  AsyncForgotPassword,
  AsyncLinkAccount,
  AsyncLogin,
  AsyncMobileRiskViewAll,
  AsyncOffers,
  AsyncOptionsAnalyticsDashboard,
  AsyncOptionsLeaderBoardPage,
  AsyncPositionAnalytics,
  AsyncPriceAlerts,
  AsyncRecoverUserAccount,
  AsyncReferences,
  AsyncReferral,
  AsyncResetPassword,
  AsyncSignup,
  AsyncSignupVerify,
  AsyncSSOLogin,
  AsyncTradeHistoryPage,
  AsyncTradingViewChartNewTab,
  AsyncUniversalSearchMobile,
  AsyncUpdatePassword,
  AsyncWithdrawalConfirmation,
  AysncTransferFundsNative,
  ConnectionStatusStrip,
  DegradedManagePositionPage,
  DegradedModeNotifyView,
  // IconsList,
  KycReduceOnlyModal,
  KycRefreshModal,
  Maintenance,
  MobileQuickLinks,
  MobileSideMenu,
  NotFound,
} from './routes/otherRoutes';

const AsyncSourceIncome = lazy(() =>
  import(/* webpackChunkName: "SourceIncome" */ 'components/SourceIncome/SourceIncome')
);

const AsyncEmailVerificationWithLink = lazy(() =>
  import(
    /* webpackChunkName: "EmailVerificationWithLink" */ 'components/Auth/EmailVerificationWithLink'
  )
);

const AsyncMobileBasketOrder = lazy(() =>
  import(
    /* webpackChunkName: "MobileBasketOrder" */ 'components/basketOrders/mobileBasketOrders'
  )
);

const AsyncReset2FA = lazy(() =>
  import(/* webpackChunkName: "Reset2FA" */ 'components/Auth/Reset2FA')
);

const AsyncBankDetailsLoader = lazy(() =>
  import(
    /* webpackChunkName: "AsyncBankDetailsLoader" */ 'components/BankDetails/BankDetails.components'
  ).then(module => ({ default: module.BankDetailsLoader }))
);

const AsyncNRIConsentPopup = lazy(() =>
  import(/* webpackChunkName: "AsyncNRIConsentPopup" */ 'components/Auth/NriConsentPopup')
);

const AsyncSpotTradingModal = lazy(() =>
  import(/* webpackChunkName: "SpotTradingModal" */ 'components/SpotTradingIndia/Modal')
);

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      rest.isloggedin ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: routes.login,
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

const App = ({
  burgerMenuIsOpen,
  closePopup,
  coin_selected,
  cookies,
  forgotPassword,
  is_currency_popup_open,
  isInternetConnected,
  isloggedin,
  isSocketReconnecting,
  location,
  logout,
  notifications,
  offlineTime,
  popupType,
  resetPassword,
  selectedProduct,
  settings,
  showPopup,
  socketDisconnectTime,
  theme,
  toggleMenu,
  toggleTheme,
  user,
  consentGiven,
}) => {
  useRNMessageEvents();
  const dispatch = useDispatch();

  const history = useHistory();

  const blockNavigationToHome = useCallback(() => {
    return history.block(location => {
      if (IS_RN_HOME_SCREEN()) {
        if (location.pathname === '/home') {
          postMessageToMobileApp(POST_MESSAGE_TO_MOBILE_EVENTS.GO_TO_HOME);
          Promise.resolve().then(() => {
            history.replace(routes.loader);
          });
          return false; // blocks the transition
        }
        if (location.pathname === '/login') {
          postMessageToMobileApp(POST_MESSAGE_TO_MOBILE_EVENTS.LOGIN_CLICKED, {
            path: location?.state?.from?.pathname,
          });
          Promise.resolve().then(() => {
            history.replace(routes.loader);
          });
          return false; // blocks the transition
        }
        if (location.pathname === '/signup') {
          postMessageToMobileApp(POST_MESSAGE_TO_MOBILE_EVENTS.SIGNUP_CLICKED, {
            path: location?.state?.from?.pathname,
          });
          Promise.resolve().then(() => {
            history.replace(routes.loader);
          });
          return false; // blocks the transition
        }

        if (IS_NATIVE_MARKETS_SCREEN() && location.pathname.includes('/markets')) {
          postMessageToMobileApp(POST_MESSAGE_TO_MOBILE_EVENTS.GO_TO_MARKETS);
          Promise.resolve().then(() => {
            history.replace(routes.loader);
          });
          return false;
        }
      }
      return true; // allow navigation
    });
  }, [history]);

  useEffect(() => {
    let unblock;
    if (isRNWebview()) {
      unblock = blockNavigationToHome();
    }
    return () => {
      unblock?.();
    };
  }, [blockNavigationToHome]);

  /**
   * Adding all namespace's here as we are loading only the file's for required languages.
   * If we dont load alerts or error's initially and then load it on demand then notifications dont render correctly.
   * Also <Suspense /> get's triggered again and whole page flashes blank screen.
   * So loading all namespaces for a particular language in start itself.
   */
  const { t } = useTranslation([
    'common',
    'trading',
    'alerts',
    'errors',
    'account',
    'auth',
    'headerFooter',
    'portfolioMargin',
    'markets',
    'errorBoundary',
    'basketOrders',
  ]);
  const WEB_ADDRESS_CHANGES_FLAG =
    !isRNWebview() && IND_DOMAIN_SWITCH && !IS_DEMO && !isDevnet;
  const [locale] = useLocalStorage('@delta/locale', 'EN');
  const [preferedExchange] = useLocalStorage(STORAGE_KEYS.INDIA_OR_GLOBAL_MODAL_CHOICE);
  const [sessionExchangePreference] = useLocalStorage(
    STORAGE_KEYS.INDIA_OR_GLOBAL_MODAL_SESSION_CHOICE,
    {}
  );
  const { whenBelowMd, whenAboveMd } = useMediaQuery();
  const activeInputFocusStatus = useSelector(activeInputFocusStatusSelector);
  const intervalRef = useRef(null);

  const {
    show_kyc_refresh_popup,
    is_kyc_refresh_required,
    show_reduce_only_popup,
    force_change_password,
    country,
  } = useSelector(state => userSelector(state));
  const isVerifiedIndianUser = useAppSelector(selectIsVerifiedIndianUser);
  const isCorporateUser = useAppSelector(selectIsCorporateUser);
  const isLiveChatEnabled = useSelector(isUserPermissionForLiveChatSelector);
  const phoneVerificationModalOpen = useAppSelector(
    state => state.other.showPhoneVerificationModal
  );
  const isSpotModalOpen = useSelector(isSpotModalOpenSelector);

  const { activeTab } = useAppSelector(appDrawerSelector);

  const isShowKycUpgradeStrip = useAppSelector(
    state => otherSelector(state).showKycUpgradeStrip
  );

  const isTradingViewFullScreen = useSelector(
    state => tradingViewChartSelector(state).isFullScreen
  );
  const [reset2faPopupShown] = useLocalStorage(
    STORAGE_KEYS.RESET_2FA_POPUP_SHOWN_KEY,
    false
  );

  const isAuthChannelDisconnected = useAppSelector(selectIsAuthChannelFailed);

  useEffect(() => {
    // Clear expired preferences after an hour
    const clearExpiredPreferences = () => {
      const { timestamp = 0 } = sessionExchangePreference;
      if (isNotEmpty(timestamp)) {
        if (Date.now() - timestamp >= EXCHANGE_PREFERENCE_SESSION_DURATION) {
          localStorage.removeItem(STORAGE_KEYS.INDIA_OR_GLOBAL_MODAL_SESSION_CHOICE);
        }
      }
    };

    // Check and redirect based on exchange preference
    const checkExchangePreference = () => {
      const { hostname, pathname, search } = window.location;

      const selectedExchange = preferedExchange || sessionExchangePreference.card;
      const exchangeURL = generateExchangeURL(selectedExchange);
      const exchangeHostname = new URL(exchangeURL).hostname;
      if (selectedExchange && exchangeHostname !== hostname) {
        navigateTo(`${exchangeURL}${pathname}${search}`);
      }
    };

    // Calls the functions to clear expired preferences and check exchange preference on mount and set interval to clear expired preferences every 15 minutes
    if (EXCHANGE_PREFERENCE_FEATURE_FLAG) {
      clearExpiredPreferences();
      checkExchangePreference();
      intervalRef.current = setInterval(clearExpiredPreferences, 15 * 60 * 1000);
    }

    return () => clearInterval(intervalRef.current);
  }, [preferedExchange, sessionExchangePreference]);

  useEffect(() => {
    if (!isloggedin) {
      localStorage.removeItem(LOCAL_STORAGE_KYC_POPUP_KEY);
      resetGrowthBookUser();
    }

    if (isloggedin && user?.id) {
      setGrowthBookUserID(user.id);
    }

    // reset basket order to default state on mobile
    if (isMobile) {
      const isBasketOrderRoute = window.location.pathname.includes('basketOrder');
      !isBasketOrderRoute && dispatch(toggleBasketOrdersView(false));
      dispatch(changeBasketOrdersScreen(BASKET_ORDERS_SCREEN_VIEW.DEFAULT));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isloggedin]);

  useEffect(() => {
    // fix only for iOS safari browser
    const unsubscribe = handleInputBlurOnScroll(document);

    return () => {
      unsubscribe?.();
    };
  }, []);

  useFullScreenChangeNotifyApp();

  useEffect(() => {
    navigator?.serviceWorker?.ready?.then(() => {
      if (navigator.serviceWorker.controller) {
        collectAndPushPerformanceDataToMixpanel();
      } else {
        navigator.serviceWorker.addEventListener(
          'controllerchange',
          collectAndPushPerformanceDataToMixpanel
        );
      }

      return () => {
        navigator.serviceWorker.removeEventListener(
          'controllerchange',
          collectAndPushPerformanceDataToMixpanel
        );
      };
    });
  }, []);

  // Handle URL parameter for opening spot modal from external sources
  useSpotModalFromURL();
  useSpotSubscription();

  useScrollToTopOnRouteChange();
  usePageVisibility();
  useAppOnlineStatus(pipe(userConnected, dispatch), pipe(userDisconnected, dispatch));

  useTrackierMobileMessage();

  useSendUserAuthorizedMessageToMobile();

  useChatwootWidget({ user, isLiveChatEnabled: isLiveChatEnabled && !isRNWebview() });

  const { shouldShowDegradedModeNotifyView, app_status } = settings;
  const isServerDegradedModeEnabled = app_status === 'degraded_mode';
  const under_maintenance = app_status === 'maintenance';

  const setUserVisitCookie = () => {
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);
    const currentDate = `${expires.getDate()}-${
      expires.getMonth() + 1
    }-${expires.getFullYear()}`;
    cookies.set('user_last_visit', currentDate, { path: '/', expires });
  };

  const deleteUserVisitCookie = () => {
    cookies.remove('user_last_visit', { path: '/' });
  };

  useEffect(() => {
    if (IS_INDIAN_EXCHANGE && cookies.get('user_last_visit')) {
      deleteUserVisitCookie();
    } else {
      setUserVisitCookie();
    }

    return () => {
      localStorage.removeItem(STORAGE_KEYS.TRADE_SUCCESS_SHARE_CARD_DATA_LOADED);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    function setCookies(value) {
      const date = new Date();
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
      cookies.set('referral_code', value, { path: '/', expires: date });
    }

    if (window.location.search.includes('code')) {
      const referral_code = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
      }).code;

      const investingClickId = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
      }).click_id;

      // regex for referral code (alpha numeric with max length 20)
      const regexp = /^[a-zA-Z0-9]{0,20}$/;
      const regexMatch = regexp.test(referral_code);
      if (regexMatch) {
        setCookies(referral_code);
        if (
          referral_code === 'InvestCom' &&
          typeof investingClickId === 'string' &&
          investingClickId
        ) {
          localStorage.setItem('investing_click_id', investingClickId);
        }
      }
    }
  }, [cookies]);

  const fullPath = window.location.pathname + window.location.search;

  const getOptionsRedirectRoute = () => {
    const { pathname } = location;
    const selectedCoin = typeof pathname === 'string' ? pathname.split('/')[3] : null;
    const selectedContract = typeof pathname === 'string' ? pathname.split('/')[4] : null;
    if (!selectedContract) {
      return routes.options_chain.trade;
    }
    if (selectedContract.includes('MV')) {
      return `${routes.move_options.trade}/${selectedCoin}/${selectedContract}`;
    }
    return `${routes.options_chain.trade}/${selectedCoin}/${selectedContract}`;
  };

  const closeConvertPopup = useCallback(
    () => dispatch(closeCurrencyConverterPopup()),
    [dispatch]
  );

  const seoKey = IS_INDIAN_EXCHANGE ? 'seoIndian' : 'seo';
  const showDeltaIndiaStrip = !IS_INDIAN_EXCHANGE && isloggedin && isVerifiedIndianUser;

  return (
    <Suspense
      fallback={
        <div style={{ flex: 1, height: '100%' }}>
          <CenterLoader />
        </div>
      }
    >
      <HelmetProvider>
        <Helmet>
          {DISABLE_SEARCH_ENGINE_CRAWLING ? (
            <meta name="robots" content="noindex, nofollow" />
          ) : (
            <meta name="robots" content="index, follow" />
          )}
          <title>{t(`common:${seoKey}.title`)}</title>
          <link
            rel="alternate"
            hrefLang={locale.toLowerCase() || 'en'}
            href={`https://www.delta.exchange${fullPath}`}
          />
          <link rel="alternate" hrefLang="x-default" href="https://www.delta.exchange/" />
          <meta name="title" content={t(`common:${seoKey}.title`)} />
          <meta name="description" content={t(`common:${seoKey}.description`)} />
          <meta
            property="og:title"
            name="og:title"
            content={t(`common:${seoKey}.title`)}
          />
          <meta
            data-rh="true"
            property="og:description"
            name="og:description"
            content={t(`common:${seoKey}.description`)}
          />
        </Helmet>

        <AppWrapper
          className="main-app"
          id="outer-container"
          isDemo={isDemo()}
          showEnvironmentMessage={checkEnvironmentMessageCondition(isloggedin)}
        >
          <ErrorBoundary>
            <RecaptchaRoot />
            <div
              data-testid={
                IS_INDIAN_EXCHANGE
                  ? 'order-notifications-india'
                  : 'order-notifications-global'
              }
            >
              <Notifications notifications={notifications} />
            </div>
            <RenderForIndianExchange>
              <Render when={isloggedin}>
                <AsyncBankDetailsLoader />
              </Render>

              <Route
                render={({ location }) => {
                  const showGoogleOneTapLogin =
                    !isRNWebview() &&
                    !isloggedin &&
                    !showComponentOnSelectedRoute([
                      routes.signup,
                      routes.login,
                      routes.verifyRegister,
                      routes.linkAccount,
                      routes.verifyEmailWithLink,
                      routes.recoverDeleteAccount,
                      routes.disable2fa,
                    ])(location);

                  return (
                    <Render when={showGoogleOneTapLogin}>
                      <GoogleOneTapLogin />
                    </Render>
                  );
                }}
              />
            </RenderForIndianExchange>
            <RenderForIndianExchange>
              <Route
                render={() => {
                  const showNRIConsentForm =
                    !isRNWebview() && !isloggedin && consentGiven;

                  return (
                    <Render when={showNRIConsentForm}>
                      <AsyncNRIConsentPopup />
                    </Render>
                  );
                }}
              />
            </RenderForIndianExchange>

            <Route
              render={({ location }) => {
                const shouldShowOnRoute =
                  isloggedin &&
                  !isDemo() &&
                  !is_kyc_refresh_required &&
                  !show_kyc_refresh_popup &&
                  !show_reduce_only_popup &&
                  shouldKYCPopupAppear() &&
                  isUserRegisteredBeforeKYCDate(user) &&
                  !user.is_kyc_done &&
                  !isUserIndian(user) &&
                  !isUserAtleastOneLevelVerified(user) &&
                  !showComponentOnSelectedRoute([
                    routes.account.identityVerification,
                    routes.login,
                  ])(location);

                return (
                  <Render when={shouldShowOnRoute}>
                    <KycModal />
                  </Render>
                );
              }}
            />
            <ConvertBlockedPopup />
            <Render when={FORCE_APP_UPDATE_FOR_NATIVE}>
              <ForceAppUpdatePopup />
            </Render>
            <RekycDetailsVerification />
            <RenderByExchange
              indian={<AnalyticsTrackingIndia />}
              global={<AnalyticsTrackingGlobal />}
            />
            <Route
              render={({ history }) => (
                <GenericPopup
                  history={history}
                  isLoggedIn={isloggedin}
                  showPopup={SHOW_POPUPS && showPopup}
                  closePopup={closePopup}
                  popupType={popupType}
                />
              )}
            />
            <Route
              render={() => {
                return (
                  <Render when={is_currency_popup_open && whenAboveMd}>
                    <CurrencyConverter coin={coin_selected} />
                  </Render>
                );
              }}
            />
            <Route
              render={({ location }) => {
                const shouldShowOnRoute = !showComponentOnSelectedRoute([
                  routes.embedChart,
                ])(location);
                return (
                  <Render when={shouldShowOnRoute && showDeltaIndiaStrip}>
                    <DeltaIndiaStrip />
                  </Render>
                );
              }}
            />
            <main id="page-wrap" className={cx('page-wrap')}>
              <div id="portal" />
              <PortalContainers />
              <Route
                render={({ location }) => {
                  const showOnRoute = showComponentOnSelectedRoute(
                    SHOW_ACCOUNT_REFRESH_TRIGGER_STRIP
                  )(location);
                  const shouldShowAccountRefreshStrip =
                    showOnRoute &&
                    isAuthChannelDisconnected &&
                    !isServerDegradedModeEnabled;
                  return (
                    <MediaQuery query={device.up.md}>
                      <Render when={shouldShowAccountRefreshStrip}>
                        <AccountRefreshTriggerStrip />
                      </Render>
                    </MediaQuery>
                  );
                }}
              />
              <Route
                render={({ location }) => {
                  const showOnRoute =
                    showComponentOnSelectedRoute(SHOW_MAINTENANCE_NOTIF)(location);

                  return (
                    <Render
                      when={
                        shouldShowKycUpgradeStrip(user, isShowKycUpgradeStrip) &&
                        showOnRoute
                      }
                    >
                      <KycUpgradeCountdownStrip />
                    </Render>
                  );
                }}
              />
              <Route
                render={({ location }) => {
                  const showComponentOnRoute =
                    showComponentOnSelectedRoute(SHOW_MAINTENANCE_NOTIF)(location);
                  const isChartTab = whenBelowMd
                    ? activeTab === APP_DRAWER_TAB_ID_MAPPING.CHART_ORDERBOOK
                    : false;

                  const showRefreshKycStrip =
                    isloggedin && showComponentOnRoute && !isChartTab;

                  return (
                    <Render when={showRefreshKycStrip}>
                      <KycRefreshDeadlineStrip />
                    </Render>
                  );
                }}
              />
              <Route
                render={({ location }) => {
                  const showComponentOnRoute = showComponentOnSelectedRoute([
                    ...SHOW_MAINTENANCE_NOTIF,
                    routes.account.withdrawal,
                  ])(location);

                  return (
                    <Render when={showComponentOnRoute}>
                      <MediaQuery query={device.up.md}>
                        <NriStripWrapper />
                      </MediaQuery>
                    </Render>
                  );
                }}
              />
              <Route
                render={({ location }) => {
                  const showComponentOnRoute = showComponentOnSelectedRoute(
                    SHOW_TRADING_REVOKED_STRIP
                  )(location);
                  const isTradeTab = activeTab === APP_DRAWER_TAB_ID_MAPPING.TRADE;
                  const isSingaporeIndividual =
                    country === 'Singapore' && !isCorporateUser;

                  const showTradingRevokedStrip = whenBelowMd
                    ? showComponentOnRoute && isTradeTab && isSingaporeIndividual
                    : showComponentOnRoute && isSingaporeIndividual;

                  return (
                    <Render when={showTradingRevokedStrip}>
                      <TradingRevokedStrip />
                    </Render>
                  );
                }}
              />
              <Route
                render={({ location }) => {
                  const showOnAllPagesExceptUpdatePsw =
                    location.pathname !== routes.updatePassword;
                  const showResetPswPopup =
                    !isDemo() &&
                    user?.showPasswordChangePopup &&
                    showOnAllPagesExceptUpdatePsw;

                  return (
                    <Render when={showResetPswPopup}>
                      <ResetPasswordPopup />
                    </Render>
                  );
                }}
              />
              <Route
                render={({ location }) => {
                  const showComponentOnRoute =
                    showComponentOnSelectedRoute(SHOW_2FA_RESET_POP_UP)(location);
                  const popUpShownBefore = JSON.parse(reset2faPopupShown);
                  const showPopup =
                    !isDemo() &&
                    user?.show2faResetPopup &&
                    showComponentOnRoute &&
                    !popUpShownBefore &&
                    isloggedin;

                  return (
                    <Render when={showPopup}>
                      <Suspense fallback={<CenterLoader />}>
                        <AsyncReset2FA />
                      </Suspense>
                    </Render>
                  );
                }}
              />
              <Route
                render={({ location }) => {
                  const showMaintenanceOnMobile =
                    showComponentOnSelectedRoute(SHOW_MAINTENANCE_NOTIF)(location);

                  return (
                    <MediaQuery query={device.down.md}>
                      <Render when={showMaintenanceOnMobile}>
                        <MaintenanceBanner isLoggedIn={isloggedin} isTopBanner />
                      </Render>
                    </MediaQuery>
                  );
                }}
              />
              <InformationStrip />
              <Route
                render={({ location }) => {
                  const showComponentOnRoute = showComponentOnSelectedRoute(
                    SHOW_SCALPER_OFFER_STRIP_ROUTES
                  )(location);

                  const isScalperOfferStripVisible =
                    isloggedin && showComponentOnRoute && SCALPING_ENABLED;

                  return (
                    <Render when={isScalperOfferStripVisible}>
                      <ScalperOfferStrip />
                    </Render>
                  );
                }}
              />
              <Route
                render={({ location }) => {
                  const showPrimaryHeader =
                    showComponentOnSelectedRoute(SHOW_PRIMARY_HEADER)(location);

                  const showPrimaryHeaderMobile =
                    showComponentOnSelectedRoute(SHOW_PRIMARY_HEADER_MOBILE)(location) &&
                    !shouldShowDegradedModeNotifyView;
                  return (
                    <>
                      <MediaQuery query={device.up.md}>
                        <Render when={showPrimaryHeader}>
                          <Render
                            when={isTradingViewFullScreen}
                            else={<PrimaryHeader isloggedin={isloggedin} />}
                          >
                            <TradingViewPrimaryHeader />
                          </Render>
                        </Render>
                      </MediaQuery>

                      <MediaQuery query={device.down.md}>
                        <Render when={showPrimaryHeaderMobile}>
                          <PrimaryHeaderMobile isloggedin={isloggedin} />
                        </Render>
                      </MediaQuery>
                    </>
                  );
                }}
              />
              <Route
                render={({ location }) => {
                  const showLiquidationRisk =
                    showComponentOnSelectedRoute(SHOW_LIQUIDATION_RISK)(location);

                  return (
                    <MediaQuery query={device.up.md}>
                      <Render when={showLiquidationRisk}>
                        <LiquidationRiskBanner />
                      </Render>
                    </MediaQuery>
                  );
                }}
              />
              <Route
                path={routes.account.default}
                render={({ ...rest }) => {
                  return (
                    <AccountHeader
                      burgerMenuIsOpen={burgerMenuIsOpen}
                      theme={theme}
                      isloggedin={isloggedin}
                      toggleMenu={toggleMenu}
                      logout={logout}
                      toggleTheme={toggleTheme}
                      selectedProduct={selectedProduct}
                      {...rest}
                    />
                  );
                }}
              />
              {shouldShowDegradedModeNotifyView &&
                location.pathname !== routes.degradedManagePosition && (
                  <DegradedModeNotifyView />
                )}
              {!shouldShowDegradedModeNotifyView && (
                <Switch location={location}>
                  {under_maintenance && location.pathname !== routes.maintenance && (
                    <Redirect to={routes.maintenance} />
                  )}
                  {isServerDegradedModeEnabled &&
                    !AUTH_PAGE_ROUTES.includes(location.pathname) &&
                    location.pathname !== routes.degradedManagePosition && (
                      <Redirect to={routes.degradedManagePosition} />
                    )}
                  <Route
                    exact
                    path={routes.degradedManagePosition}
                    render={() => {
                      return <DegradedManagePositionPage />;
                    }}
                  />
                  <Route
                    path={routes.homepage.default}
                    render={({ location }) => {
                      // Homepage does not exist in desktop view so redirecting to markets page.
                      const { search, hash } = location;
                      return (
                        <>
                          <MediaQuery query={device.up.md}>
                            <Redirect
                              to={{
                                search,
                                hash,
                                pathname: routes.options_chain.markets,
                              }}
                            />
                          </MediaQuery>
                          <MediaQuery query={device.down.md}>
                            <AsyncHomePage />
                          </MediaQuery>
                        </>
                      );
                    }}
                  />
                  {IS_INDIAN_EXCHANGE && (
                    <Redirect
                      exact
                      from={`${routes.spot.markets}/:assetSymbol`}
                      to={routes.webAppHome}
                    />
                  )}
                  {MARKET_PAGE_URLS.map(path => (
                    <Route
                      strict
                      exact
                      key={`${path}-1`}
                      path={path}
                      render={_props => {
                        return <AsyncMarkets {..._props} />;
                      }}
                    />
                  ))}
                  {TRADE_PAGE_URLS.map((path, index) =>
                    isTradingViewFullScreen ? (
                      <Route
                        exact
                        // eslint-disable-next-line react/no-array-index-key
                        key={index + 2000}
                        path={path}
                        render={_props => {
                          return <AsyncTradingViewChart {..._props} />;
                        }}
                      />
                    ) : (
                      <Route
                        path={path}
                        // eslint-disable-next-line react/no-array-index-key
                        key={index + 10}
                        render={_props => {
                          return <AsyncTrade {..._props} />;
                        }}
                      />
                    )
                  )}
                  {IS_INDIAN_EXCHANGE && (
                    <Redirect
                      from={`${routes.spot.trade}/:assetSymbol?/:productSymbol?`}
                      to={routes.webAppHome}
                    />
                  )}
                  <Route
                    exact
                    path={routes.spotIndia}
                    render={() => {
                      return <AsyncSpotTradingModal />;
                    }}
                  />
                  {IS_INDIAN_EXCHANGE && (
                    <Redirect
                      from={`${routes.spot.trade}/:assetSymbol?/:productSymbol?`}
                      to={routes.webAppHome}
                    />
                  )}
                  <PrivateRoute
                    exact
                    isloggedin={isloggedin}
                    path={routes.updatePassword}
                    component={AsyncUpdatePassword}
                  />
                  <PrivateRoute
                    exact
                    isloggedin={isloggedin}
                    path={routes.account.transferFunds}
                    component={AysncTransferFundsNative}
                  />
                  <Route
                    exact
                    path={routes.maintenance}
                    render={() => {
                      return <Maintenance />;
                    }}
                  />
                  {equals(force_change_password, true) && (
                    <Redirect to={routes.updatePassword} />
                  )}
                  <Redirect
                    strict
                    exact
                    from="/"
                    to={whenBelowMd ? routes.homepage.default : routes.webAppHome}
                    state={{ status: 301 }}
                  />
                  {[
                    `${routes.default}markets`,
                    `${routes.default}markets/`,
                    `${routes.default}trade`,
                    `${routes.default}trade/*`,
                  ].map((path, i) => (
                    <Redirect
                      strict
                      exact
                      state={{ status: 301 }}
                      from={path}
                      to={routes.webAppHome}
                      // eslint-disable-next-line react/no-array-index-key
                      key={i * 2000}
                    />
                  ))}
                  {contractTypeRedirection.map((path, i) => (
                    <Redirect
                      strict
                      exact
                      state={{ status: 301 }}
                      from={path.from}
                      to={path.to}
                      // eslint-disable-next-line react/no-array-index-key
                      key={`${i}$ß`}
                    />
                  ))}
                  {contractTypeRedirection.map((path, i) => (
                    <Redirect
                      strict
                      exact
                      state={{ status: 301 }}
                      from={`${path.from}/`} // redirection should work even after removing /
                      to={path.to}
                      // eslint-disable-next-line react/no-array-index-key
                      key={`${i}@`}
                    />
                  ))}
                  {!whenBelowMd && (
                    <Redirect
                      strict
                      exact
                      state={{ status: 301 }}
                      from={`${routes.options.trade}/*`}
                      to={getOptionsRedirectRoute()}
                    />
                  )}
                  <Route
                    strict
                    exact
                    path={routes.resources}
                    component={MobileSideMenu}
                  />
                  <Route
                    strict
                    exact
                    path={routes.usefulResources}
                    component={MobileQuickLinks}
                  />
                  <Route
                    strict
                    exact
                    path={routes.algoResources}
                    component={MobileAlgoResources}
                  />
                  {!IS_INDIAN_EXCHANGE && (
                    <Route
                      path={routes.portfolio}
                      render={() => (
                        <Redirect exact to={routes.account.portfolioMargin} />
                      )}
                    />
                  )}
                  {IS_INDIAN_EXCHANGE && (
                    <Route
                      path={routes.customLeaderBoard}
                      render={props => (
                        <AsyncOptionsLeaderBoardPage
                          {...props}
                          screen={LEADERBOARD_SCREENS.MAIN}
                        />
                      )}
                    />
                  )}
                  <Route
                    exact
                    path={routes.embedChart}
                    render={_props => <AsyncTradingViewChartNewTab {..._props} />}
                  />
                  <Route
                    exact
                    path={`${routes.expired_charts}/:symbol`}
                    component={AsyncExpiredProductCharts}
                  />
                  <Route
                    exact
                    path={routes.account.withdrawal_confirmation}
                    component={AsyncWithdrawalConfirmation}
                  />
                  <Route
                    exact
                    path={routes.universalSearchMobile}
                    component={AsyncUniversalSearchMobile}
                  />
                  <PrivateRoute
                    isloggedin={isloggedin}
                    path={routes.account.default}
                    component={AsyncAccount}
                  />
                  <Route
                    exact
                    path={routes.optionsAnalyticsDashboard.default}
                    component={AsyncOptionsAnalyticsDashboard}
                  />
                  {/* <Route path={routes.contracts} component={AsyncContracts} /> */}
                  <Route path={routes.references} component={AsyncReferences} />
                  <Route exact path={routes.api} component={AsyncApi} />
                  <Route exact path={routes.login} component={AsyncLogin} />
                  <Route exact path={routes.loader} component={RNLoader} />
                  <Route exact path={routes.linkAccount} component={AsyncLinkAccount} />
                  <Route exact path={routes.disable2fa} component={AsyncDisable2FA} />
                  <Route
                    exact
                    path={`${routes.signup}/:referral?`}
                    component={AsyncSignup}
                  />
                  <Route
                    exact
                    path={routes.verifyRegister}
                    component={AsyncSignupVerify}
                  />
                  <Route
                    exact
                    path={routes.forgotPassword}
                    render={() => <AsyncForgotPassword forgotPassword={forgotPassword} />}
                  />
                  <Route
                    exact
                    path={routes.resetPassword}
                    render={({ location }) => {
                      const params = qs.parse(location.search, {
                        ignoreQueryPrefix: true,
                      });
                      return (
                        <AsyncResetPassword
                          token={params.token}
                          resetPassword={resetPassword}
                          forgotPassword={forgotPassword}
                        />
                      );
                    }}
                  />
                  <Route
                    strict
                    exact
                    path={routes.expired_futures}
                    render={() => (
                      <Redirect exact to={routes.expired_futures_and_options} />
                    )}
                  />
                  <Route
                    strict
                    exact
                    path={routes.expired_futures_and_options}
                    component={AsyncExpiredFuturesPage}
                  />
                  {/* Don't render on testnet */}
                  {!isDemo() && (
                    <Route exact path={routes.referral} component={AsyncReferral} />
                  )}
                  <PrivateRoute
                    exact
                    isloggedin={isloggedin}
                    path={routes.bell_alerts}
                    component={AsyncBellAlerts}
                  />
                  {IS_INDIAN_EXCHANGE && (
                    <PrivateRoute
                      exact
                      isloggedin={isloggedin}
                      path={routes.ssoLogin}
                      component={AsyncSSOLogin}
                    />
                  )}

                  <Route
                    path={routes.algoMarketplace.default}
                    component={AsyncAlgoMarketplace}
                  />

                  <PrivateRoute
                    exact
                    isloggedin={isloggedin}
                    path={routes.offers}
                    component={AsyncOffers}
                  />
                  <PrivateRoute
                    exact
                    isloggedin={isloggedin}
                    path={routes.tradeHistory}
                    component={AsyncTradeHistoryPage}
                  />
                  <Route exact path={routes.logo} render={() => <Logos />} />
                  <Route
                    exact
                    path={routes.verifyEmailWithLink}
                    render={() => (
                      <Suspense fallback={<CenterLoader />}>
                        <AsyncEmailVerificationWithLink />
                      </Suspense>
                    )}
                  />
                  {/** Mobile Only Route */}
                  {whenBelowMd && (
                    <Route
                      strict
                      exact
                      path={routes.basketOrder.trade}
                      render={() => (
                        <Suspense fallback={<CenterLoader />}>
                          <AsyncMobileBasketOrder />
                        </Suspense>
                      )}
                    />
                  )}
                  {/** Mobile Only Route */}
                  {whenBelowMd && (
                    <Route
                      exact
                      path={routes.convert}
                      render={({ history }) => (
                        <>
                          <MenuBackButton
                            data-testid="mobile-back-button"
                            text={t('trading:currencyConversion.title')}
                            onBackButtonClick={() => {
                              history.goBack();
                              closeConvertPopup();
                            }}
                            showCloseIcon
                            onCrossIconClick={() => {
                              history.goBack();
                              closeConvertPopup();
                            }}
                          />
                          <CurrencyConverter coin={coin_selected || 'USDT'} />
                        </>
                      )}
                    />
                  )}
                  {/* Mobile Only Route */}
                  {whenBelowMd && (
                    <Route
                      strict
                      exact
                      path={routes.riskViewAll}
                      component={AsyncMobileRiskViewAll}
                    />
                  )}
                  {whenBelowMd && (
                    <Route
                      exact
                      path={routes.positionAnalytics}
                      component={AsyncPositionAnalytics}
                    />
                  )}
                  {whenBelowMd && (
                    <PrivateRoute
                      isloggedin={isloggedin}
                      path={routes.priceAlerts}
                      component={AsyncPriceAlerts}
                    />
                  )}
                  <Route
                    exact
                    path={routes.calculator}
                    render={props => (
                      <AsyncCalculatorPage
                        {...props}
                        onClose={() => props.history.goBack()}
                      />
                    )}
                  />

                  {/** Devnet Only Route */}
                  {/* {isDevnet && (
                  <Route exact path={routes.iconList} render={() => <IconsList />} />
                )} */}
                  {/** Ignore Trading View Charting Library route */}
                  <Route path={routes.chartingLibrary} />
                  <PrivateRoute
                    exact
                    isloggedin={isloggedin}
                    path={`${routes.balanceCoin}/:coin`}
                    component={BalanceWalletCoin}
                  />
                  <Route
                    path={routes.recoverDeleteAccount}
                    render={() => {
                      return (
                        <Render
                          when={!isloggedin && RECOVER_USER_ACCOUNT_FEATURE_ENABLED}
                        >
                          <AsyncRecoverUserAccount />
                        </Render>
                      );
                    }}
                  />
                  <Route
                    path={routes.forgotEmailId}
                    render={() => {
                      return (
                        <Render when={!isloggedin && FORGOT_EMAIL_ID_ENABLED && !IS_DEMO}>
                          <AsyncForgotEmailId />
                        </Render>
                      );
                    }}
                  />
                  {/** No Match Route */}
                  <Route path="*">
                    <NotFound />
                  </Route>
                </Switch>
              )}
              <Route
                render={({ location }) => {
                  return (
                    <Render
                      when={
                        showComponentOnSelectedRoute(SHOW_MOBILE_FOOTER)(location) &&
                        !activeInputFocusStatus
                      }
                    >
                      <MediaQuery query={device.down.md}>
                        <AsyncAppDrawer />
                      </MediaQuery>
                    </Render>
                  );
                }}
              />
              {/* Todo : footer never comes inside main . App needs to maintain sematic UI . */}
              <Route
                render={({ location }) => {
                  // TODO: create a whitelist location to render the app footer
                  const showOnLargeScreen = showComponentOnSelectedRoute(
                    FOOTER_PATH_LARGE_SCREENS_PATHS
                  )(location);

                  return (
                    <Render when={!window.isRNWebView}>
                      <footer>
                        <MediaQuery query={device.up.md}>
                          <Render
                            when={showOnLargeScreen && !shouldShowDegradedModeNotifyView}
                          >
                            <AppFooter />
                          </Render>
                        </MediaQuery>
                      </footer>
                    </Render>
                  );
                }}
              />
              <Route
                render={({ location }) => {
                  const showConnectionStatus =
                    showComponentOnSelectedRoute(
                      whenBelowMd ? SHOW_CONNECTION_STRIP_MOBILE : SHOW_CONNECTION_STRIP
                    )(location) && !shouldShowDegradedModeNotifyView;

                  return (
                    <Render when={showConnectionStatus}>
                      <ConnectionStatusStrip
                        isInternetConnected={isInternetConnected}
                        isSocketReconnecting={isSocketReconnecting}
                        isloggedin={isloggedin}
                        offlineTime={offlineTime}
                        socketDisconnectTime={socketDisconnectTime}
                      />
                    </Render>
                  );
                }}
              />
              <Route
                render={({ location }) => {
                  const showModalOnSelectedRoute =
                    showComponentOnSelectedRoute(SHOW_MAINTENANCE_NOTIF)(location);

                  return (
                    <Render when={show_reduce_only_popup && showModalOnSelectedRoute}>
                      <KycReduceOnlyModal />
                    </Render>
                  );
                }}
              />
              <Route
                render={({ location }) => {
                  const showRefreshModal =
                    showComponentOnSelectedRoute(SHOW_MAINTENANCE_NOTIF)(location);

                  return (
                    <Render
                      when={is_kyc_refresh_required && showRefreshModal && !IS_DEMO}
                    >
                      <KycRefreshModal />
                    </Render>
                  );
                }}
              />
              <Render when={shouldShowKycUpgradeWarning(user)}>
                <KycUpgradeModal />
              </Render>
              <Render when={isloggedin && shouldShowStateUpdateModal(user) && !IS_DEMO}>
                <MandatoryDeclarationModal />
              </Render>
              <Render when={phoneVerificationModalOpen}>
                <PhoneVerification
                  closeModal={() => dispatch(togglePhoneVerificationModal(false))}
                />
              </Render>
              <Setup2faModal />
              <Render when={isSpotModalOpen && !isOnSpotRouteNative()}>
                <Suspense fallback={<CenterLoader />}>
                  <AsyncSpotTradingModal
                    onClose={() => dispatch(toggleSpotModal(false))}
                  />
                </Suspense>
              </Render>
            </main>
            <Render when={WEB_ADDRESS_CHANGES_FLAG}>
              <IndiaOrGlobalModal />
            </Render>
            <SoftAsk />
            <AsyncSourceIncome />
            <NriModalWrapper />
          </ErrorBoundary>
        </AppWrapper>
      </HelmetProvider>
    </Suspense>
  );
};

const AppWithCookies = withCookies(App);
export default AppWithCookies;
